import { useContext } from "react";
import { EntityContext } from "./EntityProvider.js";
function useSchema() {
  const { schemaMapper } = useContext(EntityContext);
  return schemaMapper;
}
export {
  useSchema
};
//# sourceMappingURL=hooks.js.map
